import { WebphonePipSettings } from "@/hooks/useUpdateWebphonePIPSettings";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

export type WebphoneStore = {
    isRinging: boolean;
    setIsRinging: (isRinging: boolean) => void;

    hasActiveCall: boolean;
    setHasActiveCall: (hasActiveCall: boolean) => void;

    shouldClosePipWindow: boolean;
    setShouldClosePipWindow: () => void;

    webphonePipSettings: WebphonePipSettings;
    setWebphonePipSettings: (settings: WebphonePipSettings) => void;

    pipWindow: any;
    setPipWindow: (pipWindow: any) => void;

    isPipOpen: boolean;
    setIsPipOpen: (open: boolean) => void;

    isEmbedMounted: boolean;
    setIsEmbedMounted: (v: boolean) => void;

    embedSlotEl: HTMLElement | null;
    setEmbedSlotEl: (el: HTMLElement | null) => void;

    popOutWebphone: (() => Promise<void>) | null;
    setPopOutWebphone: (fn: (() => Promise<void>) | null) => void;

    isPoppedOutFromCallPanel: boolean;
    setIsPoppedOutFromCallPanel: (v: boolean) => void;
};

export const useWebphoneStore = create<WebphoneStore>()(
    immer((set, get) => ({
        isRinging: false as boolean,
        setIsRinging: (isRinging: boolean) => set({ isRinging }),

        hasActiveCall: false as boolean,
        setHasActiveCall: (hasActiveCall: boolean) => {
            const { pipWindow, webphonePipSettings, isPipOpen } = get();

            if (!hasActiveCall && isPipOpen && webphonePipSettings?.webphone_pip_only_during_calls) {
                try {
                    pipWindow.close?.();
                } catch (e) {
                    console.warn("PIPWindow could not be closed");
                }
            }

            set({ hasActiveCall });
        },

        webphonePipSettings: {},
        setWebphonePipSettings: (webphonePipSettings: WebphonePipSettings) => {
            set({ webphonePipSettings });
        },

        pipWindow: null as any,
        setPipWindow: (pipWindow: any) => set({ pipWindow }),

        isPipOpen: false as boolean,
        setIsPipOpen: (open) => set({ isPipOpen: open }),

        isEmbedMounted: false as boolean,
        setIsEmbedMounted: (v: boolean) => set({ isEmbedMounted: v }),

        embedSlotEl: null as HTMLElement | null,
        setEmbedSlotEl: (el: HTMLElement | null) => set({ embedSlotEl: el }),

        popOutWebphone: null as (() => Promise<void>) | null,
        setPopOutWebphone: (fn) => set({ popOutWebphone: fn }),

        isPoppedOutFromCallPanel: false as boolean,
        setIsPoppedOutFromCallPanel: (v: boolean) => set({ isPoppedOutFromCallPanel: v }),

        shouldClosePipWindow: false as boolean,
        setShouldClosePipWindow: () => {
            const settings = get().webphonePipSettings;
            const hasActiveCall = get().hasActiveCall;
            const isPipOpen = get().isPipOpen;

            if (hasActiveCall && isPipOpen) {
                if (!settings.webphone_pip_tab_change) {
                    set({ shouldClosePipWindow: true });
                    return;
                }

                set({ shouldClosePipWindow: false });
                return;
            }

            set({ shouldClosePipWindow: true });
        },
    }))
);
